const arDictionary = {
    "Members.Table.ID": "المعرف",
    "Members.Table.Picture": "الصورة",
    "Members.Table.FullName": "الاسم الكامل",
    "Members.Table.Email": "البريد الإلكتروني",
    "Members.Table.Mobile": "الجوال",
    "Members.Table.ViewFamily": "عرض العائلة",
    "Members.EditInfo": "تعديل المعلومات",
    "Members.Remove": "حذف",
    // ... other translations
};

export default arDictionary;
